const Roles = {
    sales_person: 'sales person',
    sales_manager: 'sales manager',
    dealer_principle: 'dealer principle',
    admin: 'admin'
};

export default Roles
